import React, { useContext } from 'react'
import { MainContext } from '../../context/Main.context';
import { LicenceTypes } from '../../utils/LicenceTypes';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import { Ellispis } from '../MorphoTab/MorphoTab.styled';
import { Tab } from '../Tab/Tab';
import {
    InputChoice,
    InputChoiceItem,
    InputChoiceLabel,
    InputChoiceWrapper,
    InputField,
    InputFieldLabel,
    InputFieldWrapper
} from '../Tab/Tab.styled';
import { AddParentButton } from './EmergencyContactTab.styled';

export const EmergencyContactTab = () => {
    const { 
        currentFormTab,
        licenceType,
        numberOfParents,
        setNumberOfParents,
        register,
        errors,
    } = useContext(MainContext);

    const ParentsForm = () => {
        var parents = [];

        for (var i = 1; i <= numberOfParents; i++) {
            parents.push(
                <div key={i}>
                    <h4>{"Responsable légal " + i}</h4>
                    <InputChoiceWrapper>
                        <InputChoiceItem>
                            <InputChoice
                                type="radio"
                                value="Mme"
                                name={"parent-gender-" + i}
                                id={"miss-gender-" + i}
                                defaultChecked
                                {...register("parent-gender-" + i)}
                            />
                            <InputChoiceLabel htmlFor={"miss-gender-" + i}>Madame</InputChoiceLabel>
                        </InputChoiceItem>
                        <InputChoiceItem>
                            <InputChoice
                                type="radio"
                                value="M"
                                name={"parent-gender-" + i}
                                id={"mister-gender-" + i}
                                {...register("parent-gender-" + i)}
                            />
                            <InputChoiceLabel htmlFor={"mister-gender-" + i}>Monsieur</InputChoiceLabel>
                        </InputChoiceItem>
                    </InputChoiceWrapper>
                    <InputFieldWrapper>
                        <InputFieldLabel htmlFor={"first-parent-" + i}>Prénom :</InputFieldLabel>
                        <InputField
                            type="text"
                            id={"first-parent-" + i}
                            name={"first-parent-" + i}
                            placeholder="Prénom"
                            {...register("first-parent-" + i, {
                                required: {
                                    value: true,
                                    message: "Veuillez entrer le prénom du responsable légal " + i
                                },
                            })}
                        />
                        <ErrorMessage message={errors["first-parent-" + i] && errors["first-parent-" + i].message} />
                    </InputFieldWrapper>
                    <InputFieldWrapper>
                        <InputFieldLabel htmlFor={"last-parent-" + i}>Nom :</InputFieldLabel>
                        <InputField
                            type="text"
                            id={"last-parent-" + i}
                            name={"last-parent-" + i}
                            placeholder="Nom"
                            {...register("last-parent-" + i, {
                                required: {
                                    value: true,
                                    message: "Veuillez entrer le nom du responsable légal " + i
                                },
                            })}
                        />
                        <ErrorMessage message={errors["last-parent-" + i] && errors["last-parent-" + i].message} />
                    </InputFieldWrapper>
                    <InputFieldWrapper>
                        <InputFieldLabel htmlFor={"address-parent-" + i}>Adresse :</InputFieldLabel>
                        <InputField
                            type="text"
                            id={"address-parent-" + i}
                            name={"address-parent-" + i}
                            placeholder="Adresse complète"
                            {...register("address-parent-" + i, {
                                required: {
                                    value: true,
                                    message: "Veuillez entrer l'adresse complète du responsable légal " + i
                                },
                            })}
                        />
                        <ErrorMessage message={errors["address-parent-" + i] && errors["address-parent-" + i].message} />
                    </InputFieldWrapper>
                    <InputFieldWrapper>
                        <InputFieldLabel htmlFor={"email-parent-" + i}>Email :</InputFieldLabel>
                        <InputField
                            type="email"
                            id={"email-parent-" + i}
                            name={"email-parent-" + i}
                            placeholder="Email"
                            {...register("email-parent-" + i, {
                                required: {
                                    value: true,
                                    message: "Veuillez entrer l'email du responsable légal " + i
                                },
                            })}
                        />
                        <ErrorMessage message={errors["email-parent-" + i] && errors["email-parent-" + i].message} />
                    </InputFieldWrapper>
                    <InputFieldWrapper>
                        <InputFieldLabel htmlFor={"phone-parent-" + i}>Téléphone :</InputFieldLabel>
                        <InputField
                            type="text"
                            id={"phone-parent-" + i}
                            name={"phone-parent-" + i}
                            placeholder="Téléphone"
                            {...register("phone-parent-" + i, {
                                required: {
                                    value: true,
                                    message: "Veuillez entrer le téléphone du responsable légal " + i
                                },
                                pattern: {
                                    value: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                                    message: "Veuillez entrer un numéro de téléphone valide"
                                }
                            })}
                        />
                        <ErrorMessage message={errors["phone-parent-" + i] && errors["phone-parent-" + i].message} />
                    </InputFieldWrapper>
                    <InputFieldWrapper>
                        <InputFieldLabel htmlFor={"work-parent-" + i}>Profession :</InputFieldLabel>
                        <InputField
                            type="text"
                            id={"work-parent-" + i}
                            name={"work-parent-" + i}
                            placeholder="Profession"
                            {...register("work-parent-" + i, {
                                required: {
                                    value: true,
                                    message: "Veuillez entrer la profession du responsable légal " + i
                                },
                            })}
                        />
                        <ErrorMessage message={errors["work-parent-" + i] && errors["work-parent-" + i].message} />
                    </InputFieldWrapper>
                </div> 
            );
        };

        return parents;
    }

    return (
        <Tab show={currentFormTab === 3}>
            <h2>{licenceType === LicenceTypes.YOUNG ? "Contact des responsables légaux" : "Contact en cas d'urgence"}</h2>
            {licenceType === LicenceTypes.YOUNG ? 
                <div>
                    <Ellispis>La personne désignée comme responsable légal 1 recevra par mail le lien de la FFHB pour remplir le dossier</Ellispis>
                    {ParentsForm()}
                    <AddParentButton 
                        onClick={() => setNumberOfParents(numberOfParents === 2 ? 1 : 2)}
                        
                    >
                        {numberOfParents === 2 ? "Supprimer responsable légal" : "Ajouter un responsable légal"}
                    </AddParentButton>
                </div> :
                <div>
                    <InputFieldWrapper>
                        <InputFieldLabel htmlFor="first-urg">Prénom :</InputFieldLabel>
                        <InputField
                            type="text"
                            id="first-urg"
                            name="first-urg"
                            placeholder="Prénom"
                            {...register("first-urg", {
                                required: {
                                    value: true,
                                    message: "Veuillez entrer le prénom du contact d'urgence"
                                }
                            })}
                        />
                        <ErrorMessage message={errors["first-urg"] && errors["first-urg"].message} />
                    </InputFieldWrapper>
                    <InputFieldWrapper>
                        <InputFieldLabel htmlFor="last-urg">Nom :</InputFieldLabel>
                        <InputField
                            type="text"
                            id="last-urg"
                            name="last-urg"
                            placeholder="Nom"
                            {...register("last-urg", {
                                required: {
                                    value: true,
                                    message: "Veuillez entrer le nom du contact d'urgence"
                                }
                            })}
                        />
                        <ErrorMessage message={errors["last-urg"] && errors["last-urg"].message} />
                    </InputFieldWrapper>
                    <InputFieldWrapper>
                        <InputFieldLabel htmlFor="phone-urg">Téléphone :</InputFieldLabel>
                        <InputField
                            type="text"
                            id="phone-urg"
                            name="phone-urg"
                            placeholder="Téléphone"
                            {...register("phone-urg", {
                                required: {
                                    value: true,
                                    message: "Veuillez entrer le téléphone du contact d'urgence"
                                },
                                pattern: {
                                    value: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                                    message: "Veuillez entrer un numéro de téléphone valide"
                                }
                            })}
                        />
                        <ErrorMessage message={errors["phone-urg"] && errors["phone-urg"].message} />
                    </InputFieldWrapper>
                </div>
            }
        </Tab>
    )
}
